"use client";
import { jsxs as r, jsx as l } from "react/jsx-runtime";
const n = ({
  title: i,
  titleId: a,
  desc: h,
  descId: d,
  ...e
}) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-ly",
    viewBox: "0 0 640 480",
    "aria-labelledby": a,
    "aria-describedby": d,
    ...e,
    children: [
      h ? /* @__PURE__ */ l("desc", { id: d, children: h }) : null,
      i ? /* @__PURE__ */ l("title", { id: a, children: i }) : null,
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "ly-a", children: /* @__PURE__ */ l("path", { d: "M166.7-20h666.6v500H166.7z" }) }) }),
      /* @__PURE__ */ r("g", { clipPath: "url(#ly-a)", transform: "matrix(.96 0 0 .96 -160 19.2)", children: [
        /* @__PURE__ */ l("path", { fill: "#239e46", d: "M0-20h1000v500H0z" }),
        /* @__PURE__ */ l("path", { fill: "#000001", d: "M0-20h1000v375H0z" }),
        /* @__PURE__ */ l("path", { fill: "#e70013", d: "M0-20h1000v125H0z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#fff",
            d: "M544.2 185.8a54.3 54.3 0 1 0 0 88.4 62.5 62.5 0 1 1 0-88.4M530.4 230l84.1-27.3-52 71.5v-88.4l52 71.5z"
          }
        )
      ] })
    ]
  }
);
export {
  n as default
};
